import { Suspense } from "react";
import { NavLink, Outlet } from "react-router-dom";

export function App() {
  return (
    <div className="app-shell">
      <header className="site-header">
        <NavLink to="/" className="wordmark" aria-label="Unc Check home">
          unc check ✦
        </NavLink>
      </header>
      <Suspense fallback={<main className="main-shell">Loading…</main>}>
        <Outlet />
      </Suspense>
    </div>
  );
}
